import { CPIManifest, DataStatus } from 'models'
import { getSingularSectionsName } from '../../../../library/utils'

interface Copy {
  title: string
  description: string
}

/*
 * A first sync is genuinely outstanding in two cases: the metric's own pipeline has not built its
 * series yet (INITIALIZING), or it has but no selected source has ever loaded a record. Anything
 * else is READY with data behind it, so the filters emptied the chart — named after the manifest's
 * own dimension when one is narrowing it, and generic when no filter can be blamed.
 */
export const getNoTrendDataCopy = (
  manifestData: CPIManifest | null,
  status?: DataStatus,
  awaitingFirstSync = false,
  selectedSection = ''
): Copy => {
  if (status === DataStatus.Initializing || awaitingFirstSync) {
    return {
      title: 'No Data Collected Yet',
      description: manifestData?.title
        ? `${manifestData.title} trends will appear here once initial data is synchronized.`
        : 'Trends will appear here once initial data is synchronized.'
    }
  }

  const visualizationParam = manifestData?.ui?.trend_chart?.user_input?.visualization_param
  const sections = visualizationParam?.sections ?? []
  const sectionName = getSingularSectionsName(visualizationParam?.sections_display_name || '')
  const isDimensioned = sections.length > 1 && !!selectedSection && !selectedSection.includes('All') && !!sectionName

  if (!isDimensioned) {
    return {
      title: 'No Data for the Selected Filters',
      description: 'This data source has no data for the selected filters. Try a different data source or time period.'
    }
  }

  return {
    title: `No ${selectedSection} ${sectionName} Data`,
    description:
      `This data source has no ${selectedSection.toLowerCase()} ${sectionName.toLowerCase()} data for the ` +
      `selected time period. Try a different ${sectionName.toLowerCase()}, data source or time period.`
  }
}
